export default "__VITE_ASSET__b9835f2a__"